import styled from "styled-components"
import { Colors } from "styles/app-styles"

export const ValuationScenarioDropdowns_s = styled.div`
  background: ${Colors.inputFocus};
  border: 1px solid ${Colors.towerGrey};
  display: flex;
  margin: -20px 15px 15px 15px;
  padding: 15px;
  > div {
    display: flex;
    flex-direction: column;
    margin-right: 20px; 
  }
  label {
    margin-bottom: 10px;
  }
`

export const ValuationContainer_s = styled.div`
  display: flex;
  margin: 0 38px;
  label {
    font-color: ${Colors.blackPearl};
  }
`

export const ValuationLabels_s = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  padding-top: 38px;
  min-width: 220px;
  label {
    height: 30px;
    margin-bottom: 4px;
    padding-top: 5px;
    width: 100%;
  }
`

export const ValuationScenarios_s = styled.div`
  display: flex;
`

export const ValuationScenarioForm_s = styled.div`
  margin: 0 5px;
  > div {
    align-items: center;
    display: flex;
    height: 30px;
    margin: 4px 0;
    width: 200px;
    > * { width: 100%; }
  }
  div.p-dropdown {
    width: 100%;
  }
`
